import { slicedToArray as _slicedToArray } from '../_virtual/_rollupPluginBabelHelpers.js';
var listeners = new Map();

var subscribe = function subscribe(listener) {
  var key = Symbol();
  listeners.set(key, listener);

  var unsubscribe = function unsubscribe() {
    listeners.delete(key);
  };

  return unsubscribe;
};

var dispatch = function dispatch(action) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = listeners[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _step$value = _slicedToArray(_step.value, 2),
          listener = _step$value[1];

      listener(action);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
};

var eventBus = {
  subscribe: subscribe,
  dispatch: dispatch
};
export default eventBus;
export { dispatch, subscribe };